<template>
  <div class="warehousing-detail">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="right"
      :show-message="false"
    >
      <el-collapse :value="collapse">
        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.JobNumberInformation') }}</span>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="right"
              :disabled="true"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="6">
                  <el-form-item
                    :label="$t('SeaExport.BusinessNo')"
                    prop="jobNo"
                  >
                    <el-input v-model="form.jobNo" no="1" />
                  </el-form-item>

                  <el-form-item
                    :label="getLob() ?$t('RailwayExport.ETD'):'ETD'"
                    prop="ETD"
                  >
                    <el-input v-model="form.etdString" no="2" />
                  </el-form-item>

                  <el-form-item
                    :label="getLob() ?$t('SeaExport.departureStation'):$t('SeaExport.PortOfLoadingAI')"
                    prop="portOfLoading"
                  >
                    <el-input v-model="form.loadingPortEnglish" no="3" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="getMAWBName()"
                    prop="mbl"
                  >
                    <el-input v-model="form.mbl" no="4" />
                  </el-form-item>

                  <el-form-item
                    :label="getCarrierName()"
                    prop="carrierId"
                  >
                    <el-input v-model="form.carrierName" no="5" />
                  </el-form-item>

                  <el-form-item
                    :label="getLob() ?$t('SeaExport.destinationStation'):$t('SeaExport.PortOfDestination')"
                    prop="portOfDestination"
                  >
                    <el-input v-model="form.destinationPortEnglish" no="6" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="getHblName()"
                    prop="hbl"
                  >
                    <el-input v-model="form.hbl" no="7" />
                  </el-form-item>
                  <el-form-item
                    :label="getFlightAndTime()"
                    prop="flightAndTime"
                  >
                    <el-input v-model="form.flightAndTime" no="8" />
                  </el-form-item>
                  <el-form-item
                    v-show="$checkPermission(['button_SEBooking_addSEBooking'])"
                    :label="$t('SeaExport.ConsignationCompany')"
                    prop="customerName"
                  >
                    <el-input v-model="form.customerName" no="9" :title="form.customerName" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="this.$t('CargoMsg.Cargo_Marks')"
                    prop="mark"
                  >
                    <el-input v-model="form.jobMark" no="jobMark" type="textarea" :rows="5" size="min" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item label="" class="auto-width" label-width="120px">
                  <div style="display: flex;justify-content: space-between">
                    <div style="font-size: 12px;font-weight: normal;color: #404144;width: 110px;">{{ $t('SeaExport.Quantity') }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;width: 110px;">{{ $t('SeaExport.Weight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;width: 110px;">{{ $t('SeaExport.Cubage') }}{{ openImperial ? 'CFT' : 'CBM' }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;width: 110px;">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;width: 110px;">{{ $t('queryJob.Density') }}kg/m³</div>
                    <div v-if="showImperialButton" style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">
                      {{ $t('CargoMsg.Cargo_ImperialUnits') }}
                      <div :class="openImperial?'el-switch is-checked':'el-switch'">
                        <span class="el-switch__core" style="width: 40px;" @click="openImperial = !openImperial" />
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <div style="display: flex">
                  <div style="display: flex;align-items: center;text-align: right; min-width: 100px;">
                    <div style="width: 100%;padding-right: 10px">
                      <span>{{ $t('SeaExport.Consignation') }} </span>
                    </div>
                  </div>
                  <el-form-item class="auto-width" label-width="0px">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                      <auto-number-input
                        v-model="form.quantityContract"
                        no="90"
                        :precision="0"
                        :min="0"
                        :disabled="true"
                        class="contract-input"
                      />
                      <div v-show="openImperial" style="display: flex;">
                        <auto-number-input
                          v-model="form.weightContractImperial"
                          no="weightContractImperial"
                          :precision="2"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.cubAgeContractImperial"
                          no="cubAgeContractImperial"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.chargeWeightImperial"
                          no="chargeWeightImperial"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                      </div>
                      <div v-show="!openImperial" style="display: flex;">
                        <auto-number-input
                          v-model="form.weightContract"
                          no="91"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.cubageContract"
                          no="92"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.chargeWeight"
                          no="93"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                      </div>
                      <auto-number-input
                        v-model="form.densityContract"
                        :precision="3"
                        :min="0"
                        no="140"
                        :disabled="true"
                        class="contract-input"
                      />
                    </div>
                  </el-form-item>
                </div>
                <div style="display: flex">
                  <div style="display: flex;align-items: center;text-align: right; min-width: 100px;">
                    <div style="width: 100%;padding-right: 10px">
                      <span>{{ $t('SeaExport.Booking') }} </span>
                    </div>
                  </div>
                  <el-form-item class="auto-width" label-width="0px">
                    <div style="display: flex;justify-content: space-between">
                      <auto-number-input
                        v-model="form.quantityBooking"
                        no="94"
                        :precision="0"
                        :min="0"
                        :disabled="true"
                        class="contract-input"
                      />
                      <div v-show="openImperial">
                        <auto-number-input
                          v-model="form.weightBookingImperial"
                          no="weightBookingImperial"
                          :precision="2"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.cubAgeBookingImperial"
                          no="cubAgeBookingImperial"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.chargeWeightBookingImperial"
                          no="chargeWeightBookingImperial"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                      </div>
                      <div v-show="!openImperial">
                        <auto-number-input
                          v-model="form.weightBooking"
                          no="95"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.cubageBooking"
                          no="96"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                        <auto-number-input
                          v-model="form.chargeWeightBooking"
                          no="97"
                          :precision="3"
                          :min="0"
                          :disabled="true"
                          class="contract-input"
                        />
                      </div>
                      <auto-number-input
                        v-model="form.densityBooking"
                        :precision="3"
                        :min="0"
                        no="141"
                        :disabled="true"
                        class="contract-input"
                      />
                    </div>
                  </el-form-item>
                </div>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    :label="$t('queryJob.WarehousingInstructions')"
                    prop="jobNo"
                  >
                    <div style="display: flex;align-items: center">
                      <el-checkbox v-model="form.ownWarehouse" no="ownWarehouse">{{ $t('queryJob.GoodsIntoThisWarehouse') }}</el-checkbox>
                      <el-checkbox v-model="form.takePhotos" no="takePhotos">{{ $t('queryJob.NeedPhotos') }}</el-checkbox>
                      <el-checkbox v-model="form.documentsAttached" no="documentsAttached">{{ $t('queryJob.AttachedDocuments') }}</el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item :label="$t('queryJob.otherInstructions')">
                    <div style="display: flex;">
                      <el-input v-model="form.otherWarehouseNotes" no="otherWarehouseNotes" type="textarea" :rows="5" size="min" />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.WarehouseInformation') }}</span>
          <!--空运出口显示-->
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="right"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="6">
                  <el-form-item
                    class="required"
                    :label="$t('Warehouse.WarehouseNo')"
                    prop="warehouseNo"
                  >
                    <el-input v-model="form.warehouseNo" no="10" style="width:95%;" :disabled="!isEditing" @change="warehouseNoChargeHandler" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('SeaExport.SerialNo')"
                    prop="serialNumber"
                  >
                    <el-input v-model="form.serialNumber" no="serialNumber" style="width:95%;" :disabled="true" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WarehouseName')"
                    prop="warehouse"
                    class="auto-width required"
                  >
                    <el-cascader
                      v-model="airportCargoTerminalDate"
                      no="11"
                      filterable
                      :disabled="!isEditing"
                      style="width:95%;"
                      :props="{ checkStrictly: true }"
                      :options="cargoTerminalOperationArray"
                      clearable
                      @change="p=> {cargoTerminalOperationChange(p)}"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Warehouseman')"
                    prop="warehouseOp"
                    class="auto-width"
                  >
                    <cargo-user-select
                      no="12"
                      :method-params="{officeId:form.opOffice,category:'role',shape:'warehouseOp'}"
                      :default-value="form.warehouseOp||''"
                      :disabled="!isEditing"
                      style="width:95%;"
                      @change="p=>{form.warehouseOp=p.value}"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="isAe"
                    :label="$t('CargoMsg.Cargo_EstimatedWarehousingTime')"
                    prop="estimatedWarehousingTime"
                  >
                    <el-date-picker
                      v-model="form.estimatedWarehousingTime"
                      no="13"
                      type="datetime"
                      :disabled="true"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    class="required"
                    :label="$t('CargoMsg.Cargo_ActualWarehousingTime')"
                    prop="warehouseInDate"
                  >
                    <el-date-picker
                      v-model="form.warehouseInDate"
                      no="14"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    v-if="isAe"
                    :label="$t('CargoMsg.Cargo_EstimatedDeliveryTime')"
                    prop="estimatedDeliveryTime"
                  >
                    <el-date-picker
                      v-model="form.estimatedDeliveryTime"
                      no="15"
                      type="datetime"
                      :disabled="true"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$t('Warehouse.ReceiptNo')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="form.receiptNo" no="17" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryCmp')"
                    prop="DeliveryCmp"
                  >
                    <el-input v-model="form.deliveryCmp" no="18" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.LicensePlate')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.truckNo" no="19" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Driver')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driver" no="20" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DriverPhone')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driverTel" no="21" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryMode')"
                    prop="outType"
                    class="auto-width"
                  >
                    <el-select
                      v-model="form.outType"
                      no="23"
                      clearable
                      style="width: 95%;"
                      :disabled="true"
                      :placeholder="$t('Message.PleaseSelect')"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in WarehouseInState.WAREHOUSE_IN_OUT_TYPE"
                        :key="index"
                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('CargoMsg.Cargo_ActualDeliveryTime')"
                    prop="warehouseOutDate"
                    class="auto-width"
                  >
                    <el-date-picker
                      v-model="form.warehouseOutDate"
                      no="16"
                      type="datetime"
                      :disabled="true"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm:ss"
                      style="width: 95%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$t('Warehouse.PalletSum')"
                    prop="palletSum"
                  >
                    <el-input-number v-model="form.palletSum" no="24" controls-position="right" :max="10" :min="0" style="width:95%;" :precision="0" :disabled="true" />
                  </el-form-item>
                  <el-form-item
                    prop="receiveDc"
                  >
                    <el-checkbox v-model="form.receiveDc" no="25" :disabled="!isEditing">{{ $t('Warehouse.ReceiveDc') }}</el-checkbox>
                  </el-form-item>
                  <el-form-item
                    prop="isBroken"
                  >
                    <el-checkbox v-model="form.broken" no="26" :disabled="!isEditing" style="width: 100%;" @change="checkboxChangeHandler">
                      <div :title="$selectByLang('', $t('Warehouse.IsNotComputationIsAffectedByDampness'))" :style="$selectByLang('', 'width: 135px;overflow: hidden;text-overflow: ellipsis;')">{{ $t('Warehouse.IsNotComputationIsAffectedByDampness') }}</div>
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    prop="brokenNum"
                  >
                    <line-label slot="label" :label="$t('Warehouse.ComputationIsAffectedByDampnessNum')" />
                    <el-input-number v-model="form.brokenQuantity" no="27" :min="0" :max="99999" controls-position="right" style="width:95%;" :precision="0" :disabled="!(isEditing && form.broken)" />
                  </el-form-item>
                  <el-form-item
                    prop="isBroken"
                  >
                    <el-checkbox v-model="form.sealCargo" no="28" :disabled="!isEditing" @change="checkboxChangeHandler">{{ $t('Warehouse.IsTheGoodsClosed') }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.SealingWeight')"
                    prop="brokenNum"
                  >
                    <el-input-number v-model="form.sealWeight" no="29" :min="0" :max="999999999999" controls-position="right" style="width:95%;" :precision="1" :disabled="!(isEditing && form.sealCargo)" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WarehouseInState')"
                    no="WarehouseInState"
                    prop="WarehouseInState"
                    class="auto-width"
                  >
                    <el-select
                      v-model="form.state"
                      no="30"
                      clearable
                      style="width: 95%;"
                      :disabled="true"
                      :placeholder="$t('Message.PleaseSelect')"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in WarehouseInState.WAREHOUSE_STATE_LIST"
                        :key="index"
                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    prop="licensePlate"
                  >
                    <line-label slot="label" :label="$t('Warehouse.DescriptionOfGoods')" />
                    <el-input v-model="form.brokenDes" no="31" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.HandlingOpinions')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.comments" no="32" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Remark')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.remarks" no="33" class="custom-textarea" type="textarea" :row="3" style="width:95%;height: 64px" :disabled="!isEditing" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="section" style="width:80%;min-width:1000px">
          <span class="title">{{ $t('Warehouse.CargoDetails') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <el-form class="spacing">
                  <el-button no="34" type="primary" :disabled="!isEditing" @click="addDetailHandler">{{ $t('Warehouse.AddCargo') }}</el-button>
                  <el-button no="35" type="danger" :disabled="!isEditing" @click="delDetailHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
                </el-form>
                <cargo-ag-grid
                  ref="goodsTable"
                  config-module="0250326"
                  :grid-options="detailList.goodGridOptions"
                  :column-defs="goodsColumn"
                  :row-data="form.warehouseInDetailList || []"
                  style="height: 200px;"
                  @gridReady="params=>{detailList.gridApi=params.api}"
                />
                <el-form-item class="auto-width">
                  <div style="display: flex;text-align: left" class="title-row">
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('CargoMsg.Cargo_NetGrossWeight') }}{{ openImperial ? '(LB)' : '(KG)' }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('CargoMsg.Cargo_GrossWeight2') + $t('CargoMsg.Cargo_Weight') }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? '(LB)' : '(KG)' }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Cubage') }}{{ openImperial ? '(CFT)' : '(CBM)' }}</div>
                  </div>
                </el-form-item>
                <el-form-item :label="' '" class="auto-width">
                  <el-input-number v-show="!openImperial" v-model="form.weightSum" no="weightSum" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.weightSumImperial" no="weightSumImperial" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="!openImperial" v-model="form.grossWeightSum" no="grossWeightSum" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.grossWeightSumImperial" no="grossWeightSumImperial" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="!openImperial" v-model="form.chargedWeightSum" no="chargedWeight" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.chargedWeightSumImperial" no="chargedWeightSumImperial" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                  <el-input-number v-model="form.quantitySum" no="quantitySum" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" />
                  <el-input-number v-show="!openImperial" v-model="form.cubageSum" no="cubageSum" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                  <el-input-number v-show="openImperial" v-model="form.cubAgeSumImperial" no="cubAgeSumImperial" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.CargoPhotos') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <el-form class="spacing">
                <el-upload
                  :action="`${URL.warehouseIn.uploadFileForWarehouseIn}?warehouseInUuid=${warehouseInUuid}`"
                  :headers="{sessionId:$store.getters.token}"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :on-change="toChooseFile"
                  :disabled="!isEditing"
                  style="display: inline-block;margin-right: 5px;"
                >
                  <el-button no="42" type="primary" :disabled="!isEditing">{{ $t('Warehouse.SelectFile') }}</el-button>
                </el-upload>

                <el-button type="danger" :disabled="!isEditing" no="43" @click="delPhotoHandler">{{ $t('Warehouse.DeleteFile') }}</el-button>
              </el-form>
              <cargo-ag-grid
                ref="photosList"
                config-module="0250327"
                :grid-options="photoList.gridOptions"
                :column-defs="photoList.photoColumn"
                :row-data="form.businessDocumentVOList"
                @gridReady="params=>{photoList.gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <div class="section" style="width:80%; min-width:1000px">
          <span class="title">{{ $t('Warehouse.OperationRequirements') }}</span>
          <div class="form-row grid-list">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <cargo-ag-grid
                  ref="opList"
                  config-module="9300014"
                  :grid-options="opList.options"
                  :column-defs="opList.opColumn"
                  :row-data="form.operationRequirementVOList"
                  @gridReady="params=>{opList.gridApi=params.api}"
                />
              </div>
            </el-form>
          </div>
        </div>
      </el-collapse>
    </el-form>

    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="fileTypeEditor.lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="itemEditEndHandler"
    />
    <!-- 选择业务弹框 -->
    <job-nos-window
      v-if="jobNosWindow.visible"
      :visible.sync="jobNosWindow.visible"
      :job-nos="jobNosWindow.jobs"
      @selectJobNoHandler="selectJobNoHandler"
    />
    <!-- 选择尺寸 -->
    <dimensions-dialog
      v-if="dimensionsDialog.visible"
      :visible.sync="dimensionsDialog.visible"
      :uuid="dimensionsDialog.uuid"
      :single-weight="dimensionsDialog.singleWeight"
      :dimension="dimensionsDialog.dimension"
      :open-imperial="openImperial"
      @sizeData="sizeDataHandler"
      @close="dimensionsDialog.visible = false"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import { detail, getJobDetailFunc, queryJobByWarehouseNoFunc } from '@/api/warehouseIn/warehouseIn'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker.vue'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import ColumnUtils from '@/utils/ColumnUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor.vue'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import { WarehouseInDetail } from '@/class/model/booking/WarehouseInDetail'
import * as NumberUtils from '@/utils/NumberUtils'
import JobNosWindow from './jobNosWindow.vue'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import DateUtils from '@/utils/dateUtils'
import CargoAgGridDimensionEditor from '@/components/Cargo/Common/CargoAgGridDimensionEditor/index.vue'
import DimensionsDialog from '@/components/Cargo/FrontEndWarehouse/components/warehouseHome/dimensionsDialog.vue'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { DocumentManage } from '@/utils/commonUtil'
import { getUuid } from '@/utils'
import { serial } from '@/components/Cargo/FrontEndWarehouse/components/util/serial/getWeight'
import lodash from 'lodash'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { LOCATION_STATE_LIST, IMPERIAL_3, AE } from '@/class/cargo/model/parameters/SystemConstants'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'

export default {
  name: 'WarehousingDetail',
  components: {
    AutoNumberInput,
    DimensionsDialog,
    JobNosWindow,
    cargoAdvanceSelect,
    cargoUserSelect,
    cargoCompanySelect,
    MxFileTypeEditor,
    CargoDateTimePicker
  },
  props: {
    warehouseInUuid: { type: String, default: () => '' },
    action: { type: String, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      WarehouseInState,
      documentTypeUtil: null,
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      URL,
      storageURL: '',
      openImperial: false, // 英制单位
      showImperialButton: false,
      cWeightIsCeil: 0,
      filter: {},
      addCargoVisible: false,
      gridApi: null,
      fileTypeEditor: {
        visible: false,
        fileId: '',
        lob: 'SE',
        fileCategory: ''
      },
      jobNosWindow: {
        visible: false,
        jobs: []
      },
      dimensionsDialog: {
        dimension: '',
        uuid: '',
        singleWeight: 0,
        visible: false
      },
      fileTypeMap: {},
      jobKeyOld: '',
      addKey: 'dimension_',
      selectAirportCargoTerminal: null, // 选择的仓库
      selectScaleConfiguration: null, // 选择的波特率配置
      airportCargoTerminalDate: [], // 仓库uuid 和 波特率配置uuid 临时字段
      cargoTerminalOperationArray: [],
      form: {
        uuid: '',
        jobKey: '',
        jobNo: '',
        serialNumber: '',
        frontEndWarehouse: true,
        warehouseNo: '',
        carrierName: '',
        flightAndTime: '',
        vessel: '',
        portOfLoading: '',
        licensePlate: '',
        customerName: '',
        brokenNum: 0,
        portOfDestination: '',
        warehouseInDateTo: '',
        warehouse: '',
        airportCargoTerminalUuid: '',
        warehouseOp: 0,
        etdString: '',
        hbl: '',
        mbl: '',
        destinationPortEnglish: '',
        loadingPortEnglish: '',
        voyageFlight: '',
        state: 0,
        createdBy: 0,
        dateCreated: 0,
        branchId: this.$store.getters.currentOfficeId,
        warehouseInDate: null,
        location: '',
        palletSum: 0,
        quantitySum: 0,
        chargedWeightSum: 0.00,
        chargedWeightSumImperial: 0.00,
        weightSum: 0.00,
        weightSumImperial: 0.00,
        cubageSum: 0.000,
        cubAgeSumImperial: 0.000,
        grossWeightSum: 0.000,
        grossWeightSumImperial: 0.000,
        quantityContract: 0,
        weightContractImperial: 0.0,
        cubAgeContractImperial: 0.0,
        chargeWeightImperial: 0.0,
        weightContract: 0.00,
        cubageContract: 0.000,
        chargeWeight: 0.00,
        densityContract: 0.0,
        quantityBooking: 0,
        weightBookingImperial: 0.00,
        cubAgeBookingImperial: 0.00,
        chargeWeightBookingImperial: 0.00,
        weightBooking: 0.00,
        cubageBooking: 0.00,
        chargeWeightBooking: 0.00,
        densityBooking: 0.0,
        version: null,
        receiptNo: '',
        deliveryCmp: '',
        truckNo: '',
        vehicleType: '',
        driver: '',
        driverTel: '',
        remarks: '',
        broken: false,
        receiveDc: false,
        brokenQuantity: 0,
        sealCargo: 0,
        brokenDes: '',
        comments: '',
        warehouseOutDate: '',
        estimatedDeliveryTime: '',
        estimatedWarehousingTime: '',
        outType: '',
        label: '',
        sealWeight: '',
        lob: this.lob,
        referenceNo: '',
        jobMark: '',
        ownWarehouse: false,
        takePhotos: false,
        documentsAttached: false,
        otherWarehouseNotes: '',
        warehouseStatus: 0, // 入库状态
        businessDocumentVOList: [],
        operationRequirementVOList: [],
        warehouseInDetailList: []
      },
      detailList: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridDimensionEditor
          }
        }
      },
      photoList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            this.onFileTypeCellFocused(event)
          },
          columnApi: null
        }, photoColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileName'),
            colId: 'fileName',
            field: 'fileName',
            width: 150,
            cellRenderer: params => {
              return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileType'),
            colId: 'fileType',
            field: 'fileType',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileSize'),
            field: 'fileSize',
            width: 200,
            cellRenderer: params => {
              return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_UploadTime'), colId: 'dateCreated', field: 'dateCreated', width: 150 },
          { headerName: this.$t('SeaExport.DocumentType'), colId: 'fileCategory', field: 'fileCategory', width: 150,
            cellRenderer: params => {
              return this.documentTypeUtil.fileTypeLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.UploadProgress'),
            colId: 'documentId',
            field: 'documentId',
            width: 115,
            cellRenderer: params => {
              if (params.value && !params.data.newData) {
                return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
              }
              if (!this.isEditing && params.data.newData) {
                return this.$t('queryJob.uploading') + '...'
              }
              return this.$t('Message.Waiting')
            }
          }
        ]
      },
      opList: {
        gridApi: null,
        options: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          columnApi: null,
          context: {
            componentParent: this
          }
        },
        opColumn: [
          {
            headerName: this.$t('CargoMsg.Cargo_OperationRequirement'), colId: 'contentDescription', field: 'contentDescription', width: 750,
            editable: false
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Finished'),
            field: 'finished',
            suppressMenu: true,
            width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: !this.isEditing,
              tag: 'el-checkbox',
              valueChanged: p => { this.onCellChange(p) }
            }
          }
        ]
      },
      opGridParams: {},
      collapse: [0, 1, 2, 3, 4, 5],
      warehouseInInfo: null
    }
  },
  computed: {
    readonly() {
      return !this.isEditing
    },
    detailListSelectedRow() {
      return this.form.warehouseInDetailList[this.detailList.goodGridOptions.selectedRowIndex]
    },
    photoListSelectedRow() {
      return this.form.businessDocumentVOList[this.photoList.gridOptions.selectedRowIndex]
    },
    isEditing() {
      return this.action !== 'look'
    },
    isAe() {
      const lob = this.form.lob ? this.form.lob : this.lob
      return lob === 'AE'
    },
    goodsColumn() {
      let list = [
        {
          headerName: this.$t('CargoMsg.Cargo_ScaleReading'),
          field: 'weighbridgeWeight',
          colId: 'weighbridgeWeight',
          pinned: 'left',
          // 是否开启编辑
          editable: () => false,
          cellRenderer: params => {
            const onWeighbridge = this.documentManage.getPath('onWeighbridge')
            return `<button type="button"><div onclick="${onWeighbridge}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Reading')}</div></button>`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ScaleWeight'),
          field: 'weighbridgeWeight',
          colId: 'weighbridgeWeight',
          pinned: 'left',
          width: 120,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TareWeight'),
          field: 'tareWeight',
          colId: 'tareWeight',
          width: 120,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GrossWeight2'),
          field: 'grossWeight',
          colId: 'grossWeight',
          width: 120,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => this.weightChange(params, false)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NetGrossWeight') + 'KGS',
          field: 'weight',
          colId: 'weight',
          width: 120,
          // 是否开启编辑
          editable: () => false,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_measurements'),
          field: 'dimension',
          colId: 'dimension',
          maxWidth: 500,
          minWidth: 300,
          editable: () => false,
          cellRenderer: params => {
            const onDimension = this.documentManage.getPath('onDimension')
            let value = params.value
            if (value && value.length > 30) {
              value = value.substring(0, 29) + '...'
            }
            return `<div><a onclick="${onDimension}('${params.data.uuid}')" style="color:#1F75D5;font-size:16px;">${value}✎</a></div>`
          }
        },
        {
          headerName: this.$t('SeaExport.SingleWeight') + 'KGS',
          field: 'singleWeight',
          colId: 'singleWeight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage2'),
          field: 'cubage',
          colId: 'cubage',
          width: 150,
          // 是否开启编辑
          editable: () => this.isEditing,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          },
          onCellValueChanged: (params) => {
            this.cubAgeChange(params, false)
          }
        }]
      if (this.openImperial) {
        list = [
          {
            headerName: this.$t('CargoMsg.Cargo_ScaleReading') + '(LB)',
            field: 'weighbridgeWeightImperial',
            colId: 'weighbridgeWeightImperial',
            pinned: 'left',
            // 是否开启编辑
            editable: () => false,
            cellRenderer: params => {
              const onWeighbridge = this.documentManage.getPath('onWeighbridge')
              return `<button type="button"><div onclick="${onWeighbridge}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Reading')}</div></button>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ScaleWeight') + '(LB)',
            field: 'weighbridgeWeightImperial',
            colId: 'weighbridgeWeightImperial',
            pinned: 'left',
            width: 120,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 2,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            },
            onCellValueChanged: (params) => this.weightChange(params, true)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TareWeight') + '(LB)',
            field: 'tareWeightImperial',
            colId: 'tareWeightImperial',
            width: 120,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 2,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            },
            onCellValueChanged: (params) => this.weightChange(params, true)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_GrossWeight2') + '(LB)',
            field: 'grossWeightImperial',
            colId: 'grossWeightImperial',
            width: 120,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 2,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            },
            onCellValueChanged: (params) => this.weightChange(params, true)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_NetGrossWeight') + '(LB)',
            field: 'weightImperial',
            colId: 'weightImperial',
            width: 120,
            // 是否开启编辑
            editable: () => false,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_measurements2'),
            field: 'dimensionImperial',
            colId: 'dimensionImperial',
            maxWidth: 500,
            minWidth: 300,
            editable: () => false,
            cellRenderer: params => {
              const onDimension = this.documentManage.getPath('onDimension')
              let value = params.value
              if (value && value.length > 30) {
                value = value.substring(0, 29) + '...'
              }
              return `<div><a onclick="${onDimension}('${params.data.uuid}')" style="color:#1F75D5;font-size:16px;">${value}✎</a></div>`
            }
          },
          {
            headerName: this.$t('SeaExport.SingleWeight') + '(LB)',
            field: 'singleWeightImperial',
            colId: 'singleWeightImperial',
            width: 120,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Cubage') + '(CFT)',
            field: 'cubAgeImperial',
            colId: 'cubAgeImperial',
            width: 150,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
            },
            onCellValueChanged: (params) => {
              this.cubAgeChange(params, true)
            }
          }]
      }
      list.push({
        headerName: this.$t('CargoMsg.Cargo_OurPallet'),
        field: 'palletNo',
        colId: 'palletNo',
        width: 150,
        editable: () => this.isEditing,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = this.getPalletConfigurations(params.value || '')
          return {
            selectProps: {
              tagValue: 'uuid',
              tagName: 'palletCode',
              staticOptions,
              filterable: true,
              filterTagNames: ['palletCode']
            }
          }
        },
        valueFormatter: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PalletConfiguration, 'uuid', params.value, 'palletCode')
        },
        onCellValueChanged: (params) => this.palletNoChange(params)
      },
      {
        headerName: this.$t('SeaExport.PackageType'),
        field: 'packing',
        colId: 'packing',
        width: 150,
        editable: () => this.isEditing,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagName: 'chineseName',
            selectType: TYPE_NAMES.basic_data_Packing,
            callbackParams: { key: 'code' },
            callbackMethodType: 'value',
            filterable: true
          }
        },
        valueFormatter: params => {
          return ColumnUtils.packingCodeLabelFun(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
        field: 'quantity',
        colId: 'quantity',
        width: 120,
        // 是否开启编辑
        editable: false,
        // 单元格绑定编辑组件
        cellEditor: 'CargoAgGridCommonInputEditor',
        // 编辑组件入参
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            precision: 0,
            max: 999999999,
            min: 0,
            controlsPosition: 'right',
            style: 'width: 100%'
          }
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks',
        colId: 'remarks',
        minWidth: 200,
        // 是否开启编辑
        editable: () => this.isEditing,
        // 单元格绑定编辑组件
        cellEditor: 'CargoAgGridCommonInputEditor',
        // 编辑组件入参
        cellEditorParams: {
          isNumber: false
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_PalletNumber'),
        field: 'palletNumber',
        colId: 'palletNumber',
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Location2'),
        field: 'storageLocation',
        colId: 'storageLocation',
        width: 150,
        editable: () => this.isEditing,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = this.getLocationConfigurations(params.value || '')
          return {
            selectProps: {
              tagValue: 'uuid',
              tagName: 'name',
              staticOptions,
              filterable: true,
              filterTagNames: ['name']
            }
          }
        },
        valueFormatter: params => {
          return ColumnUtils.storageLocationColumnUtils(params.value)
        }
      })
      return list
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onDimension', function(value) {
      context.onDimension(value)
    })
    this.documentManage.set('onWeighbridge', function(value) {
      context.onWeighbridge(value)
    })
  },
  methods: {
    async init() {
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
      // 加载英制单位配置
      await JobUtils.initImperialData(IMPERIAL_3.code).then(r => {
        this.openImperial = r
      })
      JobUtils.initImperialSetting().then(r => {
        this.showImperialButton = r
      })
    },
    async initCargoTerminalOperation() {
      this.cargoTerminalOperationArray = []
      const warehouseOperations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
        .filter(item => item.dataType === 1 && !item.deletionFlag && item.orderType === AE.code)
      const list = lodash.cloneDeep(warehouseOperations)
      for (const data of list) {
        const object = {}
        object.label = data.warehouseName
        object.value = data.uuid
        object.children = []
        if (data.scaleConfigurationList && data.scaleConfigurationList.length > 0) {
          for (const childrenData of data.scaleConfigurationList) {
            const childrenObject = {}
            childrenObject.label = childrenData.scaleIdentifier + '(' + childrenData.baudRate + ')'
            childrenObject.value = childrenData.uuid
            object.children.push(childrenObject)
          }
        }
        this.cargoTerminalOperationArray.push(object)
      }
    },
    async onShow(action, refresh, row = null) {
      await cache.load(cacheName.CONFIG)
      this.action = action
      this.initCargoTerminalOperation()
      this.storageURL = cache.config.get('StorageURL')
      this.cWeightIsCeil = Number(cache.config.get('AEcWeightCeil')) // 计费重量是否取整
      if (this.action === 'add' && refresh) {
        await this.buildNewRow(row)
      } else {
        if (refresh) {
          this.handleGetWarehouseInInfo()
        }
      }
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.TheExceeds20MBAndUploaded'))
        return
      }
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const document = {}
        document.warehouseInUuid = response.data.warehouseInUuid
        document.createdBy = response.data.createdBy
        document.dateCreated = response.data.dateCreated
        document.documentCategory = response.data.documentCategory
        document.documentId = response.data.documentId
        document.fileName = response.data.fileName
        document.fileSize = response.data.fileSize
        document.fileType = response.data.fileType
        document.fileCategory = response.data.fileCategory
        document.newData = true
        this.form.businessDocumentVOList.push(document)
      } else {
        this.$message.warning(this.$t('Message.UploadPleaseContactTheAdministrator'))
      }
    },
    onCellChange() {
    },
    handleGetWarehouseInInfo() {
      this.loading = getLoading()
      const { warehouseInUuid } = this
      this.clearPage()
      detail({ warehouseInUuid: warehouseInUuid, type: this.lob })
        .then((res) => {
          this.warehouseInInfo = res.data
          this.$emit('refreshHandler')
          Object.keys(this.form).forEach((key) => {
            this.loading.close()
            if (res.data[key]) {
              this.form[key] = res.data[key]
              this.jobKeyOld = this.form.jobKey
              this.airportCargoTerminalDate = [this.form.airportCargoTerminalUuid]
              if (key === 'warehouseInDetailList' && this.form.warehouseInDetailList.length > 0) {
                for (const detail of this.form.warehouseInDetailList) {
                  if (detail.dimension && !this.openImperial) { // 拆分长宽高件数
                    const array = detail.dimension.split('*')
                    detail.sizeLength = array[0]
                    detail.sizeWidth = array[1]
                    detail.sizeHeight = array[2]
                    detail.sizeQuantity = array[3]
                  }
                  if (detail.dimensionImperial && this.openImperial) {
                    const array = detail.dimensionImperial.split('*')
                    detail.sizeLength = array[0]
                    detail.sizeWidth = array[1]
                    detail.sizeHeight = array[2]
                    detail.sizeQuantity = array[3]
                  }
                }
              }
            }
          })
          this.calcSum()
          this.form.flightAndTime = this.voyageFlightStr()
          // 清空选中背景色
          this.detailList.gridApi.clearFocusedCell()
          this.photoList.gridApi.clearFocusedCell()
          this.opList.gridApi.clearFocusedCell()
        })
        .catch(() => {
          this.loading.close()
        })
      this.loading.close()
    },
    rowDoubleClicked(row) {

    },
    clearPage() {
      this.airportCargoTerminalDate = []
      this.selectAirportCargoTerminal = null
      this.selectScaleConfiguration = null
      this.form = PriceUtils.resetFilter(this.form)
    },
    getSubmitData() {
      // 直接在 this.form 上修改，避免不必要的拷贝
      this.form.lob = this.lob
      this.form.branchId = this.$store.getters.currentOfficeId

      // 如果仓库明细列表存在，直接修改 uuid
      if (this.form.warehouseInDetailList) {
        this.form.warehouseInDetailList.forEach(ind => {
          if (ind.uuid.includes(this.addKey)) {
            ind.uuid = ''
          }
        })
      }
      // 返回深拷贝的 this.form，避免外部修改影响原始数据
      return {
        form: { ...this.form }
      }
    },
    checkboxChangeHandler() {
      if (!this.form.broken) {
        this.form.brokenQuantity = 0
      }
      if (!this.form.sealCargo) {
        this.form.sealWeight = 0
      }
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      this.$emit('refreshHandler')
      this.clearPage()
      this.form.frontEndWarehouse = true
      this.form.warehouseOp = this.$store.getters.userId
      this.form.warehouseInDate = DateUtils.formatStandardDateTime(new Date())

      // 来自待入库清单的业务 提前放在页面上
      if (row && row.job) {
        const job = row.job
        this.form.jobNo = job.jobNo
        this.form.etdString = job.etd
        this.form.loadingPortEnglish = ColumnUtils.portLabelFunc(job, job.loadingPortCode)
        this.form.mbl = job.mbl
        this.form.hbl = job.hawb
        this.form.carrierName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', job.carrierId, 'chineseName')
        this.form.destinationPortEnglish = ColumnUtils.portLabelFunc(job, job.destinationPortCode)
        this.form.flightAndTime = job.voyageFlight
        this.form.customerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', job.customerId, 'chineseName')
        this.form.jobMark = job.mark
        this.form.ownWarehouse = job.ownWarehouse
        this.form.takePhotos = job.takePhotos
        this.form.documentsAttached = job.documentsAttached
        this.form.otherWarehouseNotes = job.otherWarehouseNotes
        this.form.warehouseNo = job.warehouseNo
        this.form.estimatedWarehousingTime = job.estimatedDateOfWarehousinge
        this.form.showJobUuid = job.uuid
        this.form.quantityContract = job.quantityContract
        this.form.weightContractImperial = job.weightContractImperial
        this.form.cubAgeContractImperial = job.cubAgeContractImperial
        this.form.chargeWeightImperial = job.chargeWeightImperial
        this.form.weightContract = job.weightContract
        this.form.cubageContract = job.cubageContract
        this.form.chargeWeight = job.chargeWeight
        this.form.densityContract = job.densityContract
        this.form.quantityBooking = job.quantityBooking
        this.form.weightBookingImperial = job.weightBookingImperial
        this.form.cubAgeBookingImperial = job.cubAgeBookingImperial
        this.form.chargeWeightBookingImperial = job.chargeWeightBookingImperial
        this.form.weightBooking = job.weightBooking
        this.form.cubageBooking = job.cubageBooking
        this.form.chargeWeightBooking = job.chargeWeightBooking
        this.form.densityBooking = job.densityBooking
      }
    },
    // 加入货物
    addDetailHandler() {
      const detail = new WarehouseInDetail().fillDefaultValue().getData()
      detail.uuid = this.addKey + getUuid()
      detail.warehouseInUuid = this.form.uuid
      detail.dimension = '0*0*0*1'
      detail.sizeLength = 0
      detail.sizeWidth = 0
      detail.sizeHeight = 0
      detail.sizeQuantity = 1
      detail.quantity = 1
      detail.grossWeight = 0
      detail.weight = 0.00
      detail.cubage = 0.000
      detail.singleWeight = 0.00
      detail.dimensionImperial = '0*0*0*1'
      detail.grossWeightImperial = 0
      detail.weightImperial = 0.00
      detail.cubAgeImperial = 0.000
      detail.singleWeightImperial = 0.00
      const staticOptions = getCacheListByKey(basicCacheKeys.basic_data_LocationConfiguration).filter(p => !p.deletionFlag)
      // 只有一个库位直接带出
      if (staticOptions && staticOptions.length === 1) {
        detail.storageLocation = staticOptions[0].uuid
      }
      this.form.warehouseInDetailList.push(detail)
      this.calcSum()
    },
    // 删除货物
    delDetailHandler() {
      if (this.detailListSelectedRow) {
        const index = this.detailList.goodGridOptions.selectedRowIndex
        if (index > -1) {
          this.form.warehouseInDetailList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.calcSum()
    },
    // 删除文件
    delPhotoHandler() {
      if (this.photoListSelectedRow) {
        const index = this.photoList.gridOptions.selectedRowIndex
        if (index > -1) {
          this.form.businessDocumentVOList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
    },
    // 计算
    async calcSum() {
      let quantitySum = 0
      let weightSum = 0
      let cubageSum = 0
      let grossWeightSum = 0
      let weightSumImperial = 0
      let cubAgeSumImperial = 0
      let grossWeightSumImperial = 0
      for (const detail of this.form.warehouseInDetailList) {
        quantitySum += detail.quantity
        weightSum += Number(detail.weight)
        cubageSum += Number(detail.cubage)
        grossWeightSum += Number(detail.grossWeight)

        weightSumImperial += Number(detail.weightImperial)
        cubAgeSumImperial += Number(detail.cubAgeImperial)
        grossWeightSumImperial += Number(detail.grossWeightImperial)
      }
      this.form.quantitySum = quantitySum
      this.form.weightSum = weightSum
      this.form.cubageSum = cubageSum
      this.form.grossWeightSum = grossWeightSum
      this.form.chargedWeightSum = JobUtils.calcChargeWeight(this.form.weightSum, this.form.cubageSum, true, this.cWeightIsCeil)

      this.form.weightSumImperial = weightSumImperial
      this.form.cubAgeSumImperial = cubAgeSumImperial
      this.form.grossWeightSumImperial = grossWeightSumImperial
      this.form.chargedWeightSumImperial = await JobUtils.calculateWeight(this.form.chargedWeightSum, true)
      this.form.palletSum = this.form.warehouseInDetailList.length
    },
    onDimension(uuid) {
      if (!this.isEditing) {
        return
      }
      const vo = this.form.warehouseInDetailList.find(p => p.uuid === uuid)
      if (vo) {
        if (this.openImperial) {
          this.dimensionsDialog.dimension = vo.dimensionImperial
          this.dimensionsDialog.singleWeight = vo.singleWeightImperial
        } else {
          this.dimensionsDialog.dimension = vo.dimension
          this.dimensionsDialog.singleWeight = vo.singleWeight
        }
      }
      this.dimensionsDialog.uuid = uuid
      this.dimensionsDialog.visible = true
    },
    cargoTerminalOperationChange(p) {
      this.selectAirportCargoTerminal = null
      this.selectScaleConfiguration = null

      this.form.warehouse = ''
      this.form.airportCargoTerminalUuid = ''
      if (this.form.warehouseInDetailList.length > 0) {
        for (const detail of this.form.warehouseInDetailList) {
          detail.palletNo = ''
          detail.storageLocation = ''
        }
      }
      if (p) {
        const [uuid, cUuid] = p
        const warehouseOperations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
          .filter(item => item.uuid === uuid)
        if (warehouseOperations.length > 0) {
          const wo = warehouseOperations[0]
          this.selectAirportCargoTerminal = { ...wo }
          this.form.warehouse = this.selectAirportCargoTerminal.warehouseName
          this.form.airportCargoTerminalUuid = this.selectAirportCargoTerminal.uuid
          if (wo.scaleConfigurationList && cUuid) {
            const sc = wo.scaleConfigurationList.filter(item => item.uuid === cUuid)
            if (sc.length > 0) {
              this.selectScaleConfiguration = { ...sc[0] }
            }
          }
        }
      }
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    async onWeighbridge(uuid) {
      if (!this.isEditing) {
        return
      }
      if (!this.selectScaleConfiguration) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReadingTip2'))
        return
      }
      const vo = this.form.warehouseInDetailList.find(p => p.uuid === uuid)
      if (vo && vo.uuid) {
        await this.readScaleHandler(0, this.selectScaleConfiguration.baudRate, this.selectScaleConfiguration.parityBit, vo)
        setTimeout(() => {
          this.detailChange(vo, false)
        }, 1500)
      }
    },
    // 读磅
    readScaleHandler(n, baudRate, parityBit, vo) {
      serial(baudRate, parityBit).then(res => {
        if (res === undefined && n < 5) {
          n++
          return this.readScaleHandler(n, baudRate, parityBit, vo)
        }
        vo.weighbridgeWeight = res
        this.detailList.goodGridOptions.api.refreshCells({ force: true })
      })
    },
    palletNoChange(params) {
      if (params.data.palletNo) {
        const options = getCacheListByKey(basicCacheKeys.basic_data_PalletConfiguration).filter(p => !p.deletionFlag && p.uuid === params.data.palletNo)
        if (options) {
          params.data.tareWeight = Number(options[0].palletTareWeight)
        }
      }
      this.weightChange(params, false)
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 重量改变
    weightChange(params, imperial) {
      // 净毛重 = 地磅重量 - 皮重 + 配重
      const data = params.data
      this.detailChange(data, imperial)
    },
    async detailChange(data, imperial) {
      if (imperial) {
        data.weighbridgeWeight = await JobUtils.calculateWeight(data.weighbridgeWeightImperial)
        data.tareWeight = await JobUtils.calculateWeight(data.tareWeightImperial)
        data.grossWeight = await JobUtils.calculateWeight(data.grossWeightImperial)
      }
      data.weight = NumberUtils.ToFixed2(Number(data.weighbridgeWeight || 0) - Number(data.tareWeight || 0) + Number(data.grossWeight || 0), 3)
      data.weightImperial = await JobUtils.calculateWeight(data.weight, true)
      // 单件重量 = 重量/件数
      if (data.quantity && data.weight) {
        data.singleWeight = NumberUtils.ToFixed2(Number(data.weight) / Number(data.quantity), 2)
        data.singleWeightImperial = await JobUtils.calculateWeight(data.singleWeight, true)
      } else {
        data.singleWeight = 0
      }
      if (!imperial) {
        data.weighbridgeWeightImperial = await JobUtils.calculateWeight(data.weighbridgeWeight, true)
        data.tareWeightImperial = await JobUtils.calculateWeight(data.tareWeight, true)
        data.grossWeightImperial = await JobUtils.calculateWeight(data.grossWeight, true)
      }
      await this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 体积改变
    async cubAgeChange(params, imperial) {
      const data = params.data
      if (imperial) {
        data.cubage = await JobUtils.calculateCubAge(data.cubAgeImperial)
      } else {
        data.cubAgeImperial = await JobUtils.calculateCubAge(data.cubage, true)
      }
      await this.calcSum()
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 文件类型 编辑保存
    itemEditEndHandler(data) {
      if (data) {
        const list = []
        for (const p of this.form.businessDocumentVOList) {
          if (p.documentId === data.fileId) {
            p.fileCategory = data.fileCategory
          }
          list.push(p)
        }
        this.form.businessDocumentVOList = list
      }
    },
    async sizeDataHandler(e) {
      console.log('e:-->', e)
      if (e.dimension && e.uuid) {
        const vo = this.form.warehouseInDetailList.find(p => p.uuid === e.uuid)
        if (vo) {
          const list = e.dimension.split(';')
          let quantity = 0
          // 英制单位
          if (this.openImperial) {
            vo.dimensionImperial = e.dimension
            const dimensionNew = []
            for (const d of list) {
              const value = d.split('*')
              if (value.length === 4) {
                const sizeLength = Number(value[0]) || 0
                const sizeWidth = Number(value[1]) || 0
                const sizeHeight = Number(value[2]) || 0
                const sizeQuantity = Number(value[3]) || 0
                // 计算公制单位
                const d = await JobUtils.calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity)
                if (d) {
                  dimensionNew.push(d)
                }
                quantity += sizeQuantity
              }
            }
            vo.cubAgeImperial = e.cubAgeImperial
            vo.cubage = e.cubAgeSum
            vo.dimension = dimensionNew.join(';')
          } else {
            vo.dimension = e.dimension

            const dimensionImperials = []
            for (const d of list) {
              const value = d.split('*')
              if (value.length === 4) {
                const sizeLength = Number(value[0]) || 0
                const sizeWidth = Number(value[1]) || 0
                const sizeHeight = Number(value[2]) || 0
                const sizeQuantity = Number(value[3]) || 0
                // 计算公制单位
                const d = await JobUtils.calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity, true)
                if (d) {
                  dimensionImperials.push(d)
                }
                quantity += sizeQuantity
              }
            }
            vo.cubAgeImperial = e.cubAgeImperial
            vo.cubage = e.cubAgeSum
            vo.dimensionImperial = dimensionImperials.join(';')
          }
          vo.quantity = NumberUtils.ToFixed2(quantity, 0)
          await this.detailChange(vo, false)
        }
      }
    },
    selectJobNoHandler(data) {
      if (!data) {
        return
      }
      this.loading = getLoading()
      this.form.flightAndTime = ''
      getJobDetailFunc({ key: data }).then(res => {
        if (res.data) {
          this.clearJobData()
          this.jobKeyOld = this.form.jobKey
          Object.keys(this.form).forEach((key) => {
            if (res.data[key]) {
              this.form[key] = res.data[key]
            }
          })
          this.form.flightAndTime = this.voyageFlightStr()
          this.form.showJobUuid = this.form.jobKey
        } else {
          this.$message.warning(this.$t('Message.FailedPleaseRefreshAndAgain'))
        }
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 根据进仓编号获取业务
    warehouseNoChargeHandler(data) {
      setTimeout(() => {
        if (data === '') {
          return
        }
        this.loading = getLoading()
        this.filter.branchId = this.$store.getters.currentOfficeId
        this.filter.warehouseNo = this.form.warehouseNo
        this.filter.frontEndWarehouse = true
        this.filter.lob = this.lob
        queryJobByWarehouseNoFunc(this.filter).then(res => {
          this.loading.close()
          const j = res.data
          if (j === null || j.length === 0) {
            return
          }
          // 一个就直接用
          if (j.length === 1) {
            this.clearJobData()
            this.jobKeyOld = this.form.jobKey
            Object.keys(this.form).forEach((key) => {
              if (j[0][key]) {
                this.form[key] = j[0][key]
              }
            })
            this.form.flightAndTime = this.voyageFlightStr()
            this.form.showJobUuid = this.form.jobKey
          } else {
            // 多个选一下
            this.jobNosWindow.visible = true
            this.jobNosWindow.jobs = res.data
          }
        }).catch((err) => {
          this.$message.error(err)
        }).finally(() => {
          this.loading.close()
        })
      }, 100)
    },
    getLob() {
      const lob = this.form.lob ? this.form.lob : this.lob
      return lob === 'RE' || lob === 'RI'
    },
    // 船公司
    getCarrierName() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = this.$t('SeaExport.AirlineCompany')
          break
        case 'SE':
        case 'SI':
          label = this.$t('SeaExport.ShippingCompany')
          break
        case 'RE':
        case 'RI':
          label = this.$t('RailwayExport.vessel')
          break
      }
      return label
    },
    // 船公司
    getFlightAndTime() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = this.$t('SeaExport.FlightAndTime')
          break
        case 'SE':
        case 'SI':
          label = this.$t('SeaExport.Vessel') + '/' + this.$t('SeaExport.Voyage')
          break
        case 'RE':
        case 'RI':
          label = this.$t('RailwayExport.voyageFlight')
          break
      }
      return label
    },
    getHblName() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = 'HAWB No.'
          break
        case 'SE':
        case 'SI':
          label = 'HB/L'
          break
        case 'RE':
        case 'RI':
          label = this.$t('SeaExport.MblNo3')
          break
      }
      return label
    },
    voyageFlightStr() {
      let value = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
        case 'RE':
        case 'RI':
          value = this.form.voyageFlight
          break
        case 'SE':
        case 'SI':
          value = this.form.vessel
          if (value.length > 0 && this.form.voyageFlight) {
            value += '/'
          }
          value += this.form.voyageFlight
          break
      }
      return value
    },
    getMAWBName() {
      let label = ''
      const lob = this.form.lob ? this.form.lob : this.lob
      switch (lob) {
        case 'AE':
        case 'AI':
          label = 'MAWB No.'
          break
        case 'SE':
        case 'SI':
          label = 'MB/L'
          break
        case 'RE':
        case 'RI':
          label = this.$t('RailwayExport.mbl')
          break
      }
      return label
    },
    // 清理job相关数据
    clearJobData() {
      this.form.jobNo = ''
      this.form.etdString = ''
      this.form.loadingPortEnglish = ''
      this.form.mbl = ''
      this.form.carrierName = ''
      this.form.destinationPortEnglish = ''
      this.form.hbl = ''
      this.form.voyageFlight = ''
      this.form.customerName = ''
      this.form.quantityContract = 0
      this.form.weightContract = 0.00
      this.form.cubageContract = 0.000
    },
    onFileTypeCellFocused(event) {
      this.photoList.gridOptions.selectedRowIndex = event.rowIndex
      if (event.column && event.column && event.column.colId === 'fileCategory') {
        this.fileTypeEdit(this.form.businessDocumentVOList[event.rowIndex])
      }
    },
    fileTypeEdit(data) {
      if (data !== null && this.isEditing) {
        this.fileTypeEditor.fileId = data.documentId
        this.fileTypeEditor.fileCategory = data.fileCategory
        this.fileTypeEditor.visible = true
      }
    },
    // 拿到可用库位
    getLocationConfigurations(nowUuid) {
      let warehouseInUuid = ''
      if (this.airportCargoTerminalDate.length > 0) {
        warehouseInUuid = this.airportCargoTerminalDate[0]
      }
      // 1.根据当前选择的仓库过滤 2.库位状态未删除的。
      // 当前正在用的默认放出来
      const list = getCacheListByKey(basicCacheKeys.basic_data_LocationConfiguration).filter(p => (!p.deletionFlag &&
        p.airportCargoTerminalUuid === warehouseInUuid) || p.uuid === nowUuid)
      const newList = []
      for (const data of list) {
        const vo = {}
        vo.name = data.locationCode + '(' + ColumnUtils.showTypeLabelFunc(data.locationStatus, LOCATION_STATE_LIST) + ')'
        vo.uuid = data.uuid
        newList.push(vo)
      }
      return newList
    },
    // 拿到可用托盘
    getPalletConfigurations(nowUuid) {
      let warehouseInUuid = ''
      if (this.airportCargoTerminalDate.length > 0) {
        warehouseInUuid = this.airportCargoTerminalDate[0]
      }
      // 1.根据当前选择的仓库过滤 2.托盘状态未删除的。3.循环托盘或者 回收托盘且未被占用
      // 当前正在用的默认放出来
      return getCacheListByKey(basicCacheKeys.basic_data_PalletConfiguration).filter(p => (!p.deletionFlag &&
        (p.recycleType === 0 || (p.recycleType === 1 && p.palletStatus !== 2)) && p.airportCargoTerminalUuid === warehouseInUuid) ||
        p.uuid === nowUuid)
    },
    suppressKeyboardEvent(param) {
      const currInput = param.event.target.attributes['data-index']
      if (currInput) {
        if (param.event.keyCode === 9 && currInput.value === 'sizeQuantity') {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.warehousing-detail {
  .custom-textarea{
    textarea{
      height: 64px;
    }
  }
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }
      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8!important;
      }
      &__arrow {
        color: #303133;
      }
    }
  }
  .spacing {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .grid-list {
    flex-direction:row;
    width: 80%;
    max-width: 950px;
    min-width: 950px;
  }

  .required .el-form-item__label {
    color: #1F75D5!important
  }
  .contract-input {
    width: 140px;
    margin-right: 8px;
    box-sizing: border-box;
  }
}

</style>
